import React, { useState, useEffect } from "react";
import { IndexesDataContext } from "./context";

import { getIndexesData } from "../services/services";

const IndexesProvider = ({ children }) => {
  const [IndexesData, setIndexesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIndexes = async () => {
      const Indexes = await getIndexesData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      setIndexesData(Indexes);
    };

    fetchIndexes();
  }, []);

  return (
    <IndexesDataContext.Provider
      value={{ IndexesData, setIndexesData, loading, error }}
    >
      {children}
    </IndexesDataContext.Provider>
  );
};

export default IndexesProvider;
